import React from 'react';
import { useParams } from 'react-router-dom';
import AdminDetailVpsComponent from "../../../components/Admin/vps/AdminDetailVpsComponent";

const AdminDetailVpsPage = () => {
    const params = useParams()
    return <AdminDetailVpsComponent vpsId={ params.vpsId } />;
}

export default AdminDetailVpsPage;